var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompletedEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    stroke: "#3E424E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 10.317H10c-3.682 0-6.667 3.127-6.667 6.985v52.38c0 3.858 2.985 6.985 6.667 6.985h60c3.682 0 6.667-3.127 6.667-6.984V17.3c0-3.857-2.985-6.984-6.667-6.984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 3.333v13.969M56.666 3.333v13.969",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.799 43.862c2.36 0 7.55.582 7.55 6.402 0 4.074-2.831 6.376-6.607 6.402-1.82-.045-3.603-.645-5.19-1.746M45.023 33.968c1.398-1.146 3.04-1.754 4.72-1.746 2.84 0 5.662 1.746 5.662 5.238 0 4.656-3.775 6.402-5.663 6.402H48.8M42.585 42.408h-3.492M21.912 47.126c.76-3.1 3.908-5.365 6.767-5.365 1.635-.04 3.215.724 4.393 2.121 1.178 1.398 1.859 3.315 1.891 5.331-.032 2.016-.712 3.933-1.89 5.33-1.18 1.398-2.76 2.161-4.394 2.122-3.47 0-7.25-3.577-7.25-10.135 0-8.942 4.833-14.308 11.6-14.308",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompletedEmpty);
export default __webpack_public_path__ + "static/media/icon-completed-empty.f65015930afdc5ec268e0418ff30c58c.svg";
export { ForwardRef as ReactComponent };